export interface IntentionDetail {
  id: string
  name: string
  slug: string | null
  description: string
  isSaved: boolean
  ritualCount: number
  practitionerCount: number
}

export interface IntentionRitual {
  id: string
  title: string
  ritualType: string
  isPaid: boolean
  fee: number | null
  feeCurrency: string | null
  duration: string
  durationType: string
  city: string | null
  state: string | null
  ritualTs: string | null
  coverImage: string | null
  user: {
    id: string
    username: string | null
    name: string | null
    profilePictureUrl: string | null
  } | null
  isSaved: boolean
}

export interface IntentionFiltersState {
  search: string
  sort: "trending" | "newest"
  price: "all" | "free" | "paid"
  format: "all" | "IN_PERSON" | "VIRTUAL_COURSE" | "SELF_GUIDED" | "SELF_GUIDED_COURSE"
  duration: "all" | "short" | "medium" | "long"
}

export interface IntentionRitualsResponse {
  rituals: IntentionRitual[]
  total: number
  page: number
  totalPages: number
}

export const RITUAL_FORMAT_LABELS: Record<string, string> = {
  all: "Format",
  IN_PERSON: "In-Person",
  VIRTUAL_COURSE: "Live Virtual",
  SELF_GUIDED: "Self-Guided",
  SELF_GUIDED_COURSE: "Self-Guided Course",
}
